import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RouteComponentProps } from "react-router"
import { ColorBackground } from "../../common/color/ColorBackground"
import { Header } from "../../common/headers"
import SideBar from "../../common/layout/sidebar.component"
import LoadingSpinner from "../../common/spinner/loading.component"
import { StockDocumentPricingTableSection } from "../../pricing/sections"
import { ProjectCommunicationSection, ProjectDetailsEditSection } from "../../project"
import {
    InventoryStockDocumentAction, InventoryStockDocumentDefinitionSelector,
} from "../../state/inventory"
import { StockDocumentSelector } from "../../state/inventory/stockdocument/selectors"
import { INVENTORY_STOCK_DIRECTION } from "../../utils/inventory"
import { StockDocumentFooter } from "../components"
import { StockDocumentTimeline } from "../sections/control"

type Params = {
    stockDocumentId: string
}

export const StockDocumentEdit = (props: RouteComponentProps<Params>) => {
    const dispatch = useDispatch()
    const apiStatus = useSelector(StockDocumentSelector.getApiStatus)
    const {name, colorCode} = useSelector(InventoryStockDocumentDefinitionSelector.getColorCodeAndName)
    const proposalHash = useSelector(StockDocumentSelector.getProposalHash)
    const isDraft = useSelector(StockDocumentSelector.isDraft)
    const direction = useSelector(StockDocumentSelector.getDirection)

    useEffect(() => {
        SideBar.activateMenu("inventory")
        dispatch(InventoryStockDocumentAction.fetch(props.match.params.stockDocumentId))
        return () => {
            dispatch(InventoryStockDocumentAction.clear())
        }
    }, [])

    if (!apiStatus.isLoaded) {
        return <LoadingSpinner/>
    }

    return (
        <>
            <ColorBackground colorCode={colorCode}/>

            <Header title={name} xPosition={"right"} color={"white"}/>

            <ProjectDetailsEditSection isEditable={true}/>

            {!isDraft && <ProjectCommunicationSection
                proposalHash={proposalHash}
                showEmailSection={direction !== INVENTORY_STOCK_DIRECTION.IN_OUT}
            />
            }

            <StockDocumentPricingTableSection/>

            {!isDraft && <StockDocumentTimeline/>}

            <StockDocumentFooter/>
        </>
    )
}


// WEBPACK FOOTER //
// ./src/inventory/pages/StockDocumentEdit.tsx